import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3505fcab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description-container" }
const _hoisted_2 = ["id", "contenteditable"]

import { ref, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'editableTextarea',
  props: {
    text: {
        type: String 
    },
    placeholder: {
        type: String,
    },
    taskId: {
        type: String,
        required: false
    },
    fieldId: {
        type: String,
        required: false
    }
},
  emits: ["editCompleted", "cancelEdit"],
  setup(__props, { emit: __emit }) {


const props = __props

const emits = __emit


const isEditing = ref<boolean>(false)

// Generate unique ID for this component instance
const componentId = computed(() => props.fieldId || `editableTextarea-${Math.random().toString(36).substr(2, 9)}`)

const startEdit = () => {
    isEditing.value = true
}

const handleNewLine = ((e) => {

    const editableDiv = document.getElementById(componentId.value)

    if(e.keyCode === 13){
        e.preventDefault();
        const selection = window.getSelection();
        const cursorPosition = selection.focusOffset;
        const text = editableDiv.textContent;
        const newText = text.slice(0, cursorPosition) + '\n' + text.slice(cursorPosition);
        editableDiv.textContent = newText;
        const newCursorPosition = cursorPosition + 1;
        const newRange = document.createRange();
        newRange.setStart(editableDiv.childNodes[0], newCursorPosition);
        newRange.setEnd(editableDiv.childNodes[0], newCursorPosition);
        selection.removeAllRanges();
        selection.addRange(newRange);
  }
})

const completeEdit = async () => {
    console.log(document.getElementById(componentId.value)?.innerHTML)
    const newDescription = document.getElementById(componentId.value)?.innerText
    if(newDescription && newDescription !== props.text){
        emits("editCompleted", newDescription)
    }

    isEditing.value = false

}


const cancelEdit = () => {
    isEditing.value = false
    emits("cancelEdit")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: componentId.value,
      contenteditable: isEditing.value,
      onDblclick: startEdit,
      onKeyup: _withKeys(cancelEdit, ["esc"]),
      onBlur: completeEdit,
      onKeydown: _withKeys(handleNewLine, ["enter"]),
      class: _normalizeClass(["task-desc", { 'desc-editing': isEditing.value,  }])
    }, _toDisplayString(props.text ? props.text : props.placeholder), 43, _hoisted_2)
  ]))
}
}

})